import { render } from "./Message.vue?vue&type=template&id=8d2d3196&scoped=true&ts=true"
import script from "./Message.vue?vue&type=script&setup=true&lang=ts"
export * from "./Message.vue?vue&type=script&setup=true&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=8d2d3196&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2d3196"],['__file',"src/views/message/Message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d2d3196"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d2d3196', __exports__)) {
    console.log('reload')
    api.reload('8d2d3196', __exports__)
  }
  
  module.hot.accept("./Message.vue?vue&type=template&id=8d2d3196&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('8d2d3196', render)
  })

}


export default __exports__